<div class="customer-information-container d-flex flex-column">
    <div class="customer-information-content">
        <fieldset class="mt-3 pb-0 ps-0 col-sm-8">
            <div class="customer-info">
                <!-- Left Menu Bar -->
                <div class="menu-bar">
                    <div class="menu-item" 
                        [class.active]="selectedSection === 'accountName'" 
                        (click)="selectSection('accountName')">
                        <span class="menu-label">{{ 'ACCOUNT_NAME' | translate }}</span>
                    </div>
                    <div class="menu-item" 
                        [class.active]="selectedSection === 'shipToLocation'" 
                        (click)="selectSection('shipToLocation')">
                        <span class="menu-label">{{ 'SHIP_TO_LOCATION' | translate }}</span>
                    </div>
                    <div class="menu-item" 
                        [class.active]="selectedSection === 'billTO'" 
                        (click)="selectSection('billTO')">
                        <span class="menu-label">{{ 'BILL_TO' | translate }}</span>
                    </div>
                    <div class="menu-item" 
                        [class.active]="selectedSection === 'endUser'" 
                        (click)="selectSection('endUser')">
                        <span class="menu-label">{{ 'END_USER' | translate }}</span>
                    </div>
                </div>

                <!-- Right Content Area -->
                <div class="content-area">
                    <div>
                        @if(shouldShowApplySoldToCheckbox()){
                        <div class="sold-to-checkbox">
                            <mat-checkbox color="primary" [checked]="isApplySoldToChecked()" [disabled]="!hasSoldToAccountSelected() || isReadOnlyMode" 
                            (change)="onApplySoldToChange($event.checked)" > 
                            {{ 'APPLY_SOLD_TO_ACCOUNT' | translate }}</mat-checkbox>
                        </div>
                    }
                    @for(item of customerData; track item.label){
                        <div class="info-row">
                            <div class="info-label">{{ item.label | translate }}:</div>
                            <div class="info-value">{{ item.value }}</div>
                        </div>
                    }
                    </div>
                    <div class="icon-container">
                        <mat-icon [class.readonly-field]="isReadOnlyMode" [attr.aria-disabled]="isReadOnlyMode" (click)="searchCustomers()">more_horiz</mat-icon>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="customer-information-footer d-flex justify-content-end">
        <button class="openCloseBtn" mat-raised-button color="primary" [disabled]="!enableBtn() || isReadOnlyMode" (click)="clearData()">{{ 'CLEAR' | translate }}</button>
        <button class="openCloseBtn" mat-raised-button color="primary" (click)="saveCustomerInfo()" [disabled]="isReadOnlyMode">{{ 'OK' | translate}}</button>
        <button class="openCloseBtn" mat-raised-button color="warn" mat-dialog-close (click)="onCancel()">{{'CANCEL' | translate}}</button>
    </div>
</div>
